module.exports = {
	"version": 2,
	"waiters": {
		"AlarmExists": {
			"delay": 5,
			"maxAttempts": 40,
			"operation": "DescribeAlarms",
			"acceptors": [
				{
					"matcher": "path",
					"expected": true,
					"argument": "length(MetricAlarms[]) > `0`",
					"state": "success"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/monitoring-2010-08-01.waiters2.json
// module id = 728
// module chunks = 2